import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footer from "../layouts/Footerthree";
import Content from "../sections/ThinkToKnow/TermsContent";
import Download from "../layouts/App";
import { useTranslation } from "react-i18next";

const Termsandcond = () => {
  const {t} = useTranslation();
  return (
    <Fragment>
      <Helmet>
        <title>
          Acres - Real Estate React Template | Terms and Conditions
        </title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb
        breadcrumb={{ pagename: t("terms_condition")}}
      />

      <Content />
      <Download />
      <Footer />
    </Fragment>
  );
};

export default Termsandcond;
